class HelperPlugin {
  isFormCompleted (obj) {
    let isValid = true
    for (const i in obj) {
      isValid = isValid && (obj[i] !== null && obj[i] !== undefined)
      if (!isValid) return isValid
    }
    return isValid
  }

  parserGroupsInValidChartItems (a) {
    const x = []
    const y = []
    const colors = []
    const texts = []
    const annotations = []
    const lines = []

    let currentGroup
    let total = 0
    let currentOriginPlace
    let currentOriginPlaceX
    const positionLineAnnotation = 0
    const yAnnotiation = 0
    const formatter = new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' })
    a.forEach(element => {
      if (!currentOriginPlace) {
        currentOriginPlace = element.originPlace
        currentOriginPlaceX = element.group
        annotations.push({
          t: 'originPlace',
          x: element.group,
          y: yAnnotiation,
          text: element.originPlace,
          hoverinfo: 'skip',
          xanchor: 'bottom',
          yanchor: 'bottom',
          showarrow: false,
          textangle: positionLineAnnotation
        })
      }

      if (element.originPlace !== currentOriginPlace) {
        if (currentOriginPlaceX !== element.group) {
          lines.push({
            x: [currentOriginPlaceX, element.group],
            y: [0, 0],
            type: 'scatter',
            hoverinfo: 'skip',
            showlegend: false
          })
          annotations.push({
            t: 'originPlace',
            x: element.group,
            y: yAnnotiation,
            text: element.originPlace,
            xanchor: 'bottom',
            yanchor: 'bottom',
            hoverinfo: 'skip',
            showarrow: false,
            textangle: positionLineAnnotation
          })
        }
        currentOriginPlace = element.originPlace
        currentOriginPlaceX = element.group
      }

      if (currentGroup && element.group !== currentGroup) {
        currentOriginPlace = element.group

        x.push(element.group)
        y.push(total)
        texts.push('')
        colors.push('white')
        annotations.push({
          x: currentGroup ?? element.group,
          y: (total + total * 0.05),
          text: `${formatter.format(total)}`,
          hoverinfo: 'skip',
          xanchor: 'center',
          yanchor: 'bottom',
          showarrow: false
        })
      }

      currentGroup = element.group
      total += element.value
      x.push(element.group)
      y.push(element.value)
      texts.push(element.text)
      colors.push(element.color)
    })
    annotations.push({
      x: currentGroup,
      y: (total + total * 0.05),
      text: `${formatter.format(total)}`,
      hoverinfo: 'skip',
      xanchor: 'center',
      yanchor: 'bottom',
      showarrow: false
    })
    return {
      total: total,
      x,
      y,
      colors,
      texts,
      annotations,
      lines
    }
  }

  isValid (arr, i = 0, value = 0) {
    if (i >= arr.length) return true

    if (arr[0].order !== 1) return false

    if (i > 0 && arr[i - 1].id === arr[i].id) return false

    if (arr[i].description.toLowerCase() !== 'transporte' && arr[i].order < value) return false

    if (arr[i].description.toLowerCase() === 'transporte') return this.isValid(arr, i + 1, value)

    return this.isValid(arr, i + 1, arr[i].order)
  }

  orderIsValidate (arr, element) {
    if (!this.isValid(arr)) {
      arr.splice(element.newIndex, 1)
      arr.splice(element.oldIndex, 0, element.element)
      return false
    }
    return true
  }

  addedOrderIsValidate (arr, element) {
    if (!this.isValid(arr)) {
      arr.splice(element.newIndex, 1)
      return false
    }
    return true
  }

  onlyNumber (event) {
    if (event.key === '.' || event.key === ',' || event.key === '-') { event.preventDefault() }
  }

  onlyDecimal (event) {
    if (event.key === ',' || event.key === '-') { event.preventDefault() }
  }
}
export default HelperPlugin
